import type { Contact } from "../types";

type ContactSegment = NonNullable<Contact["segments"]>[number];

export const ContactSegmentsList = ({
  segments,
}: {
  segments?: Contact["segments"];
}) => {
  const items = (segments ?? []) as ContactSegment[];

  if (items.length === 0) {
    return (
      <p className="text-xs text-muted-foreground">Ingen segmenter endnu.</p>
    );
  }

  return (
    <div className="space-y-1">
      {items.map((s) => {
        const label = s.description ?? s.number;
        return (
          <div
            key={s.bc_segment_id ?? s.number}
            className="flex items-center justify-between gap-4"
          >
            <span className="text-sm">{label}</span>
            <span className="text-xs text-muted-foreground">{s.number}</span>
          </div>
        );
      })}
    </div>
  );
};

